module.exports = __webpack_public_path__ + "img/values-stewardship.dd115561.gif";